import { render, staticRenderFns } from "./report-manager.vue?vue&type=template&id=5dcf314c&"
import script from "./report-manager.vue?vue&type=script&lang=js&"
export * from "./report-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports